/** @module csi/widget/_svg/ShapeAlignBottom */
define([
	"./_ShapeAlign",
	"./PluginFactory"
], function(_ShapeAlign,PluginFactory) {

	return PluginFactory.declare(_ShapeAlign, {
		/**
		 * @property {String} iconClass - CSS class to be applied.
		 */
		iconClass: "csiActionIcon svgIconAlignBottom",		

		/**
		 * @property {String} pluginName - Plugin name to be used for adding to toolbar.
		 */
		pluginName: "shapeAlignBottom",

		/**
		 * @property {String} title - Title for the plugin icon.
		 */
		title: "CanvasShapeAlignBottom",

		/**
		 * @property {String} shapeAlignOption - Shape align option: Top.
		 */
		shapeAlignOption: "bottom"
	});
});
